import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

/**
 * ContentsSlider Component
 * @param {any} param0
 * @returns
 */
const ContentsSlider = ({
  initialSlide,
  onChangeSlide,
  contentsCount,
  // 2024.9.16 MyMine Version2.0対応 Add Start
  slidesToShow,
  // 2024.9.16 MyMine Version2.0対応 Add End
  children }) => {

  const SlickArrowLeft = ({ currentSlide, slideCount, className, ...props }) => (
    <Box className={className.replace('slick-prev')} {...props} sx={{ position: 'absolute', width: 30, top: '40%', left: '-3%' }}>
      <ArrowBackIosIcon sx={{ color: 'black', cursor: 'pointer' }} />
    </Box>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, className, ...props }) => (
    <Box className={className.replace('slick-next')} {...props} sx={{ position: 'absolute', width: 30, top: '40%', right: '-3%', paddingLeft: 1 }}>
      <ArrowForwardIosIcon sx={{ color: 'black', cursor: 'pointer' }} />
    </Box>
  );

  const settings = {
    infinite: true,
    speed: 500,
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    slidesToShow: contentsCount >= slidesToShow ? slidesToShow : contentsCount,
    slidesToScroll: slidesToShow,
    // 2024.9.16 MyMine Version2.0対応 Modify End
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    afterChange: onChangeSlide,
    initialSlide: initialSlide,
    touchMove: false,
  };

  return (
    <Container>
      <Slider {...settings}>
        {children}
      </Slider>
    </Container>
  );
};
export default ContentsSlider;
